<template>
    <div>
        <b-card
            :sub-title="nombre"
            :img-src="laFoto"
            img-alt="foto"
            img-top
            class="mb-2 text-center"
        >
            <b-card-text>
                {{ puesto }}
            </b-card-text>
            <hr>

            <b-card-text>
                <small>{{ telefono }}</small>
            </b-card-text>
            
        </b-card>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'Persona',
    props: {
        nombre: {
            type: String,
            default: ''
        },
        foto: {
            type: String,
            default: ''
        },
        puesto: {
            type: String,
            default: ''
        },
        telefono: {
            type: String,
            default: ''
        },
    },
    computed: {
        laFoto() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                if (this.foto != '') {
                    return `${this.urlSandbox}/doctos/fotos/${this.foto}`
                } else {
                    return `${this.urlSandbox}/doctos/fotos/sinfotodir.jpg`
                }
            } else {
                if (this.foto != '') {
                    return `${this.urlProd}/doctos/fotos/${this.foto}`
                } else {
                    return `${this.urlProd}/doctos/fotos/sinfotodir.jpg`
                }
            }
            
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>

</style>